import React, { useEffect, useState } from 'react'
import styles from '../../styles/casestudy.module.css'
import Image from 'next/image'
import TestimonialSection from '../common/TestimonialSection'
import { testimonialData, videoTestimonial } from '@/constants/common'
import content from '../../language/ENGLISH.json'
import PersonalisedDemoBanner from '../common/PersonalisedDemoBanner'
import VerificationPopup from '../modals/VerificationPopup'
import TrustFactor from '../common/TrustFactor'
import FrequentQuestions from '../homePage/FrequentQuestions'
import { useRouter } from 'next/router'
import MobileTestimonialSection from '../common/MobileTestimonialSection'
import FAQ_mobile from '../Industry/FAQ_mobile'
import MobilePDBanner from '../common/MobilePDBanner'
import { headers } from 'next.config'

const IRCTC = () => {
    const { testimonialHeadText } = content.testimonial;
    const [demoModal, setDemoModal] = useState(false);
    const [formHeading, setHeading] = useState("Book your free demo now!");
    const [mobileView, setmobileView] = useState(0);
    const router = useRouter()

    const setWindowDimensions = () => {
        window.innerWidth > 600 ? setmobileView(0) : setmobileView(1);
    };

    useEffect(() => {
        setWindowDimensions();
        window.addEventListener("resize", setWindowDimensions);
        return () => {
            window.removeEventListener("resize", setWindowDimensions);
        };
    }, []);

    const engagementSnap = [
        {
            title: <>  Implemented in<b> 1 train</b><br /> over  <b>3 weeks</b></>,
            tag: "Pilot Phase",
            tagColor: "#C9F6FF",
            bgColor: "#EDFBFE",
            width: "44%",
            mobileWidth: "48%"
        },
        {
            title: <>Deployed in <b>750+</b><br />  <b>trains</b></>,
            tag: "Rollout Phase",
            tagColor: "#F8D378",
            bgColor: "#FFF6E4",
            width: "54%",
            mobileWidth: "49%"
        },
        {
            title: <><b>1 seamless</b> Integration </>,
            tag: "Integrations",
            tagColor: "#87F1D5",
            bgColor: "#EDFEF9",
            width: "54%",
            mobileWidth: "48%"
        },
        {
            title: <><b>100% </b> Printed Bills</>,
            tag: "Outcome",
            tagColor: "#EEC9FF",
            bgColor: "#FCF7FF",
            width: "44%",
            mobileWidth: "49%"
        }
    ]

    const qbPOS = [
        {
            title: "Real-Time Insights",
            description: "Real-time visibility and insights for better decision-making.",
            icon: "/assets/caseStudy/hul/realtime-insights.svg"
        },
        {
            title: "Robust Software",
            description: "A powerful, flexible solution tailored for complex supply chains.",
            icon: "/assets/caseStudy/hul/robust-software.svg"
        },
        {
            title: "Seamless integration",
            description: "Smaff integration with your current systems to ensure operations are done without hitches.",
            icon: "/assets/caseStudy/hul/integration.svg"
        },
        {
            title: "Exceptional Support",
            description: "A dedicated customer support team to ensure operations are done seamlessly.",
            icon: "/assets/caseStudy/hul/support.svg"
        },
    ]
    const faqs = [
        {
            para: (
                <span style={{ width: "90%" }}>
                    How can QueueBuster POS help streamline operations for a small business?
                </span>
            ),
            des: "QueueBuster POS can largely streamline functions for a small business. This is possible through the implementation and incorporation of numerous functions available under the same roof. Basically, it offers the feature of real-time sales tracking, which means a business owner can track the transactions and sales trends taking place in the business, thereby gaining business intelligence related to peak hours of sales and popular products. The feature of inventory management helps to automatically update stock quantities with each sale, ruling out overstock or stockouts. Customer relationship management tools trace the preferences of customers and their purchase histories, enabling quite directly targeted marketing and increasing customer loyalty. By virtue of having all these functions in a single place, QueueBuster POS saves you time, decreases operational complexity, and generally increases operational business efficiency.",
            id: 1,
            activeIndex: 1,
        },
        {
            para: (
                <span style={{ width: "90%" }}>
                    How to set up QueueBuster POS for the first time?
                </span>
            ),
            des: "The first-time setup of QueueBuster POS involves account creation, hardware configuration, software installation, and some initial configuration, say business name and a few products. The starting point for QueueBuster POS involves the account creation at the QueueBuster platform. Upon signing up for the account and filling in some basic business information, one needs to connect and configure any specific hardware such as a card reader and barcode scanner. Next, the QueueBuster app is downloaded and installed on an Android device or POS terminal. Upon logging in, users complete the initial setup by configuring business settings like tax rates, payment methods, and user permissions. Inventory is then added by inputting product details or uploading bulk inventory lists. Finally, staff training on using the system ensures smooth operations from day one.",
            id: 2,
            activeIndex: 0,
        },
        {
            para: (
                <span style={{ width: "90%" }}>
                    How does QueueBuster POS handle multi-location businesses?
                </span>
            ),
            des: "It's going to streamline multi-location businesses like anything by putting everything under centralized control with real-time synchronization of data. At a centralized level, it brings a dashboard to business owners in giving them an account of sales and inventory performance at an individual location. Through real-time data synchronization, this system will enable sales transactions and changes to why the inventory levels take place at the central office, updating the stock level. Each location can be managed independently, with its own settings, while contributing to overall business analytics. QueueBuster POS also facilitates the process of stock transfers between different locations and assists in the generation of consolidated reports that provide insights into the performance of every location and overall business.",
            id: 3,
            activeIndex: 0,
        },
        {
            para: (
                <span style={{ width: "90%" }}>
                     How can QueueBuster POS help in managing seasonal inventory fluctuations?
                </span>
            ),
            des: "The sales forecasting tool predicts future demand based on past sales data. This enables you to plan your inventory according to expected sales for the next selling season. Automated reordering ensures that, in the event of stock falling below a preset reorder level, stocks never fall below customer demand. Inventory alerts help businesses keep track of the current levels of their stocks so that steps can be taken proactively to manage inventory and avoid stockouts. This system also supports other types of seasonal product management, like organizing the inventory and allowing for targeted promotion of seasonal items. Real-time inventory tracking tracks stock levels in real time, even during the highest volumes of sale, making it easy to manage the seasonal fluctuations",
            id: 4,
            activeIndex: 0,
        },
        {
            para: (
                <span style={{ width: "90%" }}>
                     What are the advantages of using QueueBuster POS for mobile payments?
                </span>
            ),
            des: "Mobile payments allow customers to pay from their smartphones and, in return, will improve faster checkouts and less waiting time by ensuring convenience. Mobile payments secure transactions through encryption and tokenization, making fraud less commonplace. QueueBuster POS, with its in-built hardware support for NFC technology, allows it to accept contactless payments in order to ensure hygiene and security while customers pay. Integration of the major mobile wallets, like Apple Pay, Google Pay, and Samsung Pay, means the customers have every option for the payment processor. This flexibility increases overall customer satisfaction, which in turn translates to the capability of businesses to increase sales by serving a wider customer base.",
            id: 5,
            activeIndex: 0,
        },
        {
            para: (
                <span style={{ width: "90%" }}>
                    In what way does QueueBuster POS help in the implementation of customer loyalty programs?
                </span>
            ),
            des: "In addition, businesses can set up flexible loyalty programs in which customers earn points for every purchase. The earned points could be redeemed for discounts, free products, or special offers. Real-time monitoring of customer purchases and their points accumulation is provided within the system, with deeper insights into customer behavior for further visibility into how the program is performing. The process of earning and redemption of points for customers is streamlined with digital membership cards. At the POS, the QueueBuster POS automates the issuing of rewards, offering a seamless experience to the customers. Integration with marketing tools enables businesses to send special promotion-driven, personalized offers to loyalty members, driving up engagement and repeat visitations.",
            id: 6,
            activeIndex: 0,
        },
        {
            para: (
                <span style={{ width: "90%" }}>
                    How does QueueBuster POS help in raising inventory accuracy and lowering shrinkage?
                </span>
            ),
            des: "Any sale, return, or restocking is immediately reflected in the current quantity count, hence maintaining levels of stocks at a maximum. Detailed Inventory reports help to identify discrepancies and keep track of stock movements hence regular audits can be done. Barcode scanning saves time at checkout. Less manual keying means fewer errors in entries and more accurate inventory records are maintained. Alerts on low stock levels indicate to businesses well in advance stock levels to manage their supplies better and thereby prevent loss. The optional integration of QueueBuster POS with weighing scales makes exact billing possible and carries out an inventory of the weight-based products. In addition, greater employee accountability and restricted access to inventory management features will help reduce the possibility of internal theft and error.",
            id: 7,
            activeIndex: 0,
        },
        {
            para: (
                <span style={{ width: "90%" }}>
                    How does QueueBuster POS facilitate easy integration with third-party apps and services?
                </span>
            ),
            des: "The APIs ease the work of developers requiring an interaction of QueueBuster with accounting software, e-commerce platformers, CRM tools, etc. in order to have complete business solutions. With some of the most popular apps in the market pre-integrated, much time and effort in setup is saved, dealing directly with needed functions—from payment processing to loyalty programs and inventory setup. When businesses have unique requirements, the architecture of QueueBuster can be customized and integrates with all the other stuff that a business might choose to include in the POS system for it to be uniquely their own. Seamless syncing of data is then guaranteed, which would see to flow sales data, inventory levels, customer information, and financial records between QueueBuster POS and these third-party apps in a most functional and efficient manner.",
            id: 8,
            activeIndex: 0,
        },
        {
            para: (
                <span style={{ width: "90%" }}>
                    How can the QueueBuster POS help in managing employee performance and accountability?
                </span>
            ),
            des: "It tracks and logs all actions of employees, including selling, inventory, communication with the customer, and many other actions. That transparency enables the owner to control what the employees are doing and pinpoint anomalies. Role-based permissions shall allow only those accessibilities, which shall concern an employee and hence minimize unauthorized activities. Performance reports from a POS system shall avail insight into the leading performers and areas that need special attention. Together, these functions improve employee accountability and help in optimizing workforce management.",
            id: 9,
            activeIndex: 0,
        },
        {
            para: (
                <span style={{ width: "90%" }}>
                     How does QueueBuster POS help businesses adhere to tax requirements?
                </span>
            ),
            des: "Businesses can configure systems in accordance with local regulations on tax rates to ensure correct computation of tax on every transaction. During sales, QB POS automatically applies the correct tax rates, therefore minimizing the risk of errors. These detailed tax reports evidently would provide an overview that businesses need for easily filing tax returns as well as complying with the laws and regulations that are in place. Such reports may summarize details with the capability to comply with particular compliance needs to make sure businesses have all the mandatory information for tax reporting on time and accurately. ",
            id: 10,
            activeIndex: 0,
        },
    ]
    const BusinessInsights=[
        {
            image:"/assets/caseStudy/irctc/heineken.webp",
            header:"Case Study",
            title:"BreathingRoom achieves shorter sales cycle and faster revenue realisation with Razorpay.",
            text:"Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore ",
        },
        {
            image:"/assets/caseStudy/irctc/mobile-hero-img.webp",
            header:"Case Study",
            title:"BreathingRoom achieves shorter sales cycle and faster revenue realisation with Razorpay.",
            text:"Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore ",
        },
        {
            image:"/assets/caseStudy/irctc/mobile-hero-img.webp",
            header:"Blog",
            title:"BreathingRoom achieves shorter sales cycle and faster revenue realisation with Razorpay.",
            text:"Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore ",
        }
    ]
    return (
        <>
            <div className={styles.verificationPopupOverride}>
                <VerificationPopup isOpen={demoModal} closeModal={() => setDemoModal(false)} formHeading={formHeading} />
            </div>
            <div className={styles.hero_section}>
                {
                    mobileView ?
                        <div className={styles.mobile_hero_img} style={{ backgroundImage: "url('/assets/caseStudy/irctc/new-mobile-hero-irctc-img.webp')" }}>
                            <div>
                                <h1>How <span className={styles.blue_text}>QueueBuster</span> Transformed Train Catering Services for IRCTC</h1>
                                <div className={styles.hero_content}>
                                    <div>
                                        <p>750+</p>
                                        <p>Trains</p>
                                    </div>
                                    <div>
                                        <p>80%</p>
                                        <p>Improvements</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                        :
                        <div className={styles.hero_section_inner_container}>
                            <div className={styles.hero_section_image}><Image src="/assets/caseStudy/irctc/new-irctcImage.webp" alt="irctc hero image" fill /></div>
                            <div className={styles.hero_heading1}><h1>How QueueBuster Transformed Train Catering Services for IRCTC
                            </h1></div>
                            <div className={styles.hero_content}>
                                <div>
                                <p>750+</p>
                                <p>Trains</p>
                                </div>
                                <div>
                                    <p>80%</p>
                                    <p>Improvements</p>
                                </div>
                                <div>
                                    <p>100%</p>
                                    <p>of Transactions with Print</p>
                                </div>
                            </div>
                        </div>
                }
                <div className={styles.light_blue_box}>
                    <div>
                        <p>About IRCTC</p>
                        <p>Indian Railway Catering and Tourism Corporation (IRCTC) is an Indian public sector undertaking that provides ticketing, catering, and tourism services for the state-owned Indian Railways. In the quest to improve the passenger experience, IRCTC aimed to initiate a revamp of the train pantry service, including the automation of train pantry billing.</p>
                    </div>
                    <div>
                        <p>Deployed Solution</p>
                        <p>QueueBuster collaborated with multiple tender awardees to integrate a full-fledged billing and inventory management solution for Pine Labs card-swiping machines. It will transform the huge, unorganized train pantry sector into an efficient and operationally transparent business.</p>
                    </div>
                </div>
                <div className={styles.owner_words}>
                    <p>"QueueBuster is hands-on the best Android-based POS solution available in the market today. We couldn't think of anyone beyond QueueBuster to help us with the train catering requirements posted by IRCTC. The GUI is so simple that it hardly takes a few minutes to train a new staff member.”</p>
                    <p className={styles.name}> Mr. Mrityunjay</p>
                    <p className={styles.position}>New Initiatives – Pine Labs</p>
                </div>
            </div >
            <div className={styles.section_two}>
                <div>
                    <div className={styles.problem_statement}>
                        <p className={styles.orange_heading}>Problem Statement</p>
                        <p>IRCTC had to computerize its train pantry services with the help of handheld billing machines, in a manner to bring operational efficiency, transparency, and printed receipts for every transaction. A tender was floated by the government inviting innovative proposals from interested providers for the same.</p>
                        <p className={styles.green_heading}>Outcomes</p>
                        <p>This has added immense value to passengers, pantry operators, and even government officials as the introduction of printed bills for every purchase is formally introducing what was otherwise an unorganized sector—some initiative that is fast entrenching a culture of transparency and accountability.</p>
                    </div>
                    <div className={styles.blue_box}>
                        <div style={{position:'relative', width:"7rem", height:"7rem"}}><Image src="/assets/caseStudy/irctc/irctc.svg" alt="irctc" fill /></div>
                        <div className={styles.row}>
                            <p className={styles.light_heading}>Industry Type</p>
                            <p>Public Sector Undertaking</p>
                        </div>
                        <div className={styles.row} style={{ display: "flex", gap: "3rem" }}>
                            <div>
                                <p className={styles.light_heading}>Type of Business</p> 
                                <p>Hospitality</p>
                            </div>
                            <div>
                                <p className={styles.light_heading}> Employees</p>
                                <p>2500+</p>
                            </div>
                        </div>
                        <div className={styles.row}>
                            <p className={styles.block}>Catering</p>
                            <p className={styles.block}>Transportation</p>
                            <p className={styles.block}>Technology</p>
                            <p className={styles.block}>Mobile POS</p>
                            
                        </div>
                    </div>
                </div>
                <div>
                    <p className={styles.pink_heading}>Engagement Snapshot</p>
                    <div style={{ display: "flex", flexWrap: "wrap", gap: "1rem" }}>
                        {
                            engagementSnap?.map((ele) => {
                                return (
                                    <div style={{ backgroundColor: ele?.bgColor, width: mobileView ? ele?.mobileWidth : ele?.width, padding: mobileView ? "1.5rem" : "3.75rem", borderRadius: "1rem" }}>
                                        <p style={{ font: mobileView ? "normal normal normal 1.8rem/3rem Inter" : "normal normal normal 2.4rem/3rem Inter" }}>{ele?.title}</p>
                                        <div style={{ backgroundColor: ele?.tagColor, padding: "1rem 2rem", borderRadius: "70px", width: "fit-content", marginTop: "2rem" }}>{ele?.tag}</div>
                                    </div>
                                )
                            })
                        }
                    </div>
                </div>
            </div>
            <div className={styles.qb_POS}>
                <h3>Why Choose QueueBuster POS?</h3>
                <div className={styles.qb_POS_container}>
                    {
                        qbPOS?.map((ele) => {
                            return (
                                <div>
                                    <div style={{ height: "5rem", width: "5rem", position: "relative", margin: "2rem auto" }}><Image src={ele?.icon} alt={ele?.title} fill /></div>
                                    <p style={{ font: "normal normal 500 1.8rem/2.6rem Inter", textAlign: "center" }}>{ele?.title}</p>
                                    <p style={{ font: "normal normal normal 1.4rem/2rem Inter", textAlign: "center", color: "#6F7F96" }}>{ele?.description}</p>
                                </div>
                            )
                        })
                    }
                </div>
            </div>
            <div className={styles.supply_chain}>
                <div>
                    <h4>Transform Your Supply Chain with QueueBuster POS</h4>
                    <p>QueueBuster POS is dedicated to providing innovative solutions that streamline operations, and enhance visibility across the supply chain, and with our powerful software, businesses like HUL are able to maintain better planning, forecasting, and overall efficiency.</p>
                </div>
                <div style={{ height: mobileView ? "15rem" : "20rem", width: mobileView ? "27rem" : "35rem", position: "relative" }}><Image src="/assets/caseStudy/hul/supply_chain.webp" alt="upply Chain with QueueBuster POS" fill /></div>
            </div> <br />

            {/* <div>
                <div className={styles.section_heading}><h3>Transform Your Supply Chain with QueueBuster POS</h3> <div className={styles.heading_stroke}></div> <Image src="" fill alt='/assets/'/></div>
                
                <div className={styles.BusinessInsights_container} >
                {    
                BusinessInsights.map((ele, index) => (
                    <div key={index} >
                        <div  className={styles.BusinessInsights_image}  style={{ backgroundImage: `url(${ele.image})` }} >
                        


                        <div className={styles.BusinessInsights_content}>
                            <p>{ele.header}</p>
                            <p>{ele.title}</p>
                            <p>{ele.text}</p>
                            <div className={styles.ViewCaseStudy}><p>View Case Study</p> <div className={styles.arrow_outward}><Image src='/assets/caseStudy/arrow_outward.svg' fill/></div></div>
                        </div>
                        </div>
                    </div>
                  
                ))
                }
                </div>

            </div> */}

            <div className={styles.other_components}>
                <div className={styles.section_heading}><h3>{testimonialHeadText}</h3> <div className={styles.heading_stroke}><Image src='/assets/strokes_svg/testimonials_hl.svg' alt='industries' fill /></div></div>
                {
                    mobileView ? <MobileTestimonialSection testimonialData={testimonialData} videoTestimonial={videoTestimonial} /> :
                        <TestimonialSection testimonialData={testimonialData} videoTestimonial={videoTestimonial} />
                }
            </div>
            <div className={styles.other_components}>{
                mobileView ? <MobilePDBanner setDemoModal={setDemoModal} setHeading={setHeading} /> : <PersonalisedDemoBanner setDemoModal={setDemoModal} setHeading={setHeading} />
            }</div>
            <div style={{ margin: mobileView ? "0 3rem" : "0 5rem" }}><TrustFactor /></div>
            <div>{
                mobileView ?
                    <FAQ_mobile FaqTableData={faqs} width={"auto"} heading={"Frequently Asked Questions"} />
                    :
                    <FrequentQuestions FaqTableData={faqs} heading={"Frequently Asked Questions"} />
            }</div>
        </>
    )
}

 
export default IRCTC
